import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as fromStore from '../../../store';
import { CompanyInfo } from '../../../store/actions/company-info.action';
import { TextUtils } from '../../utils/text-utils';

export type SupportedLanguage = 'en' | 'it' | 'es' | 'de' | 'fr' | 'nb' | 'ru' | 'pt-PT' | 'nl' | 'da';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private _currentLanguage$ = new BehaviorSubject<SupportedLanguage>('en');

  constructor(private _store: Store<fromStore.DbStoreState>) {
    this._initializeLanguage();
  }

  private _initializeLanguage(): void {
    this._store.select(fromStore.getCompanyInfo)
      .pipe(
        filter((companyInfo: CompanyInfo) => !!companyInfo)
      )
      .subscribe((companyInfo: CompanyInfo) => {
        const language = companyInfo.branding?.dashboard_language as SupportedLanguage;
        if (language && this._isValidLanguage(language)) {
          this.setLanguage(language);
        }
      });
  }

  private _isValidLanguage(lang: string): lang is SupportedLanguage {
    return ['en', 'it', 'es', 'de', 'fr', 'nb', 'ru', 'pt-PT', 'nl', 'da'].includes(lang);
  }

  public getCurrentLanguage(): SupportedLanguage {
    return this._currentLanguage$.value;
  }

  public setLanguage(language: SupportedLanguage): void {
    if (this._isValidLanguage(language)) {
      this._currentLanguage$.next(language);
      TextUtils.setLanguage(language);
    }
  }
}
